import { render, staticRenderFns } from "./SessionLogs.vue?vue&type=template&id=bf12c944&scoped=true&"
import script from "./SessionLogs.vue?vue&type=script&lang=js&"
export * from "./SessionLogs.vue?vue&type=script&lang=js&"
import style0 from "./SessionLogs.vue?vue&type=style&index=0&id=bf12c944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf12c944",
  null
  
)

export default component.exports